// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"60cac173","396":"51d0b3bd","453":"1498e516","455":"b1735e55","857":"cc7b202c","977":"873c04b1"}[chunkId] + ".chunk.js";
};